<template>
  <div v-if="isRouterAlive">
    <Slider :banner="$t('sliderimg')">
      <div class="row align-items-center">
        <div class="col fontsiyuanmedium">
          <div class="slider-title fontsiyuanmedium">
            {{ $t("slidertitle") }}
          </div>
          <div class="slider-subtitle fontsiyuanregular">
            {{ $t("slidersubtitle") }}
          </div>
        </div>
      </div>
    </Slider>
    <!-- 品类标题 -->
    <div
      @mouseleave="bindProductMoveLeave"
      class="productdetail-sort-wide sticky2"
      style="z-index: 1777; background-color: #fff"
    >
      <div class="productdetail-title w-100">
        <b-container>
          <b-row class="">
            <b-col cols="8">
              <b-row>
                <b-col
                  :class="
                    `productdetail-title-item ${
                      clickType == 0
                        ? clickActiveColor
                        : moveType == 0
                        ? moveActiveColor
                        : ''
                    }`
                  "
                  @click="bindTypeClick(0, JSON.parse($t('productlist1')))"
                  @mouseenter="
                    bindTypeMoveEnter(0, JSON.parse($t('productlist1')))
                  "
                >
                  <div>
                    <span @mouseenter="bindTypeSpanMoveEnter">{{
                      $t("titlet1text")
                    }}</span>
                  </div></b-col
                >
                <b-col
                  :class="
                    `productdetail-title-item ${
                      clickType == 1
                        ? clickActiveColor
                        : moveType == 1
                        ? moveActiveColor
                        : ''
                    }`
                  "
                  @click="bindTypeClick(1, JSON.parse($t('productlist2')))"
                  @mouseenter="
                    bindTypeMoveEnter(1, JSON.parse($t('productlist2')))
                  "
                >
                  <div>
                    <span @mouseenter="bindTypeSpanMoveEnter">{{
                      $t("titlet2text")
                    }}</span>
                  </div></b-col
                >
                <b-col
                  :class="
                    `productdetail-title-item ${
                      clickType == 2
                        ? clickActiveColor
                        : moveType == 2
                        ? moveActiveColor
                        : ''
                    }`
                  "
                  @click="bindTypeClick(2, JSON.parse($t('productlist3')))"
                  @mouseenter="
                    bindTypeMoveEnter(2, JSON.parse($t('productlist3')))
                  "
                >
                  <div>
                    <span @mouseenter="bindTypeSpanMoveEnter">{{
                      $t("titlet3text")
                    }}</span>
                  </div></b-col
                >
              </b-row>
            </b-col>
            <b-col cols="2"></b-col>
            <b-col cols="2"></b-col>
          </b-row>
        </b-container>
      </div>
      <div
        class="productdetail-sort-bg sticky"
        style="z-index: 1073"
        v-if="showCategoryPanel"
      >
        <b-container class="productdetail-sort-group">
          <b-row>
            <b-col cols="8">
              <b-row>
                <b-col v-for="(item, index) in sortlist" v-bind:key="index">
                  <div v-if="clickType == moveType">
                    <div
                      v-for="(item2, index2) in item"
                      v-bind:key="index2"
                      :class="
                        `productdetail-sort ${
                          clickCategory == index * 3 + index2
                            ? clickActiveColor
                            : moveCategory == index * 3 + index2
                            ? moveActiveColor
                            : ''
                        }`
                      "
                      @mouseenter="bindCategoryMoveEnter(index * 3 + index2)"
                      @click="bindCategoryClick(index * 3 + index2)"
                    >
                      {{
                        sortlist[index][index2] +
                          (clickType == index * 3 + index2 ? "" : " ")
                      }}
                    </div>
                  </div>
                  <div v-else>
                    <div
                      v-for="(item2, index2) in item"
                      v-bind:key="index2"
                      :class="
                        `productdetail-sort ${
                          moveCategory == index * 3 + index2
                            ? moveActiveColor
                            : ''
                        }`
                      "
                      @mouseenter="bindCategoryMoveEnter(index * 3 + index2)"
                      @click="bindCategoryClick(index * 3 + index2)"
                    >
                      {{
                        sortlist[index][index2] +
                          (clickType == index * 3 + index2 ? "" : " ")
                      }}
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <!-- <b-col cols="2"></b-col>
            <b-col cols="2"></b-col> -->
          </b-row>
        </b-container>
      </div>
    </div>
    <div
      class="productdetail-sort-thin sticky2"
      style="z-index: 1777; background-color: #fff"
    >
      <b-container>
        <b-row class="productdetail-sort-thin-group">
          <b-col>
            <div
              class="thin-sort-header"
              @click="bindCatgoryClickThin(1, JSON.parse($t('productlist1')))"
            >
              <span
                :class="
                  categoryActive1 ? 'thin-sort-title-active' : 'thin-sort-title'
                "
                >{{ $t("titlet1text") }}</span
              >
              <span v-if="!categoryActive1" class="thin-sort-button">+</span>
              <span v-else class="thin-sort-button">-</span>
            </div>
          </b-col>
          <b-col>
            <div
              class="thin-sort-header"
              @click="bindCatgoryClickThin(2, JSON.parse($t('productlist2')))"
            >
              <span
                :class="
                  categoryActive2 ? 'thin-sort-title-active' : 'thin-sort-title'
                "
                >{{ $t("titlet2text") }}</span
              >
              <span v-if="!categoryActive2" class="thin-sort-button">+</span>
              <span v-else class="thin-sort-button">-</span>
            </div>
          </b-col>
          <b-col>
            <div
              class="thin-sort-header"
              @click="bindCatgoryClickThin(3, JSON.parse($t('productlist3')))"
            >
              <span
                :class="
                  categoryActive3 ? 'thin-sort-title-active' : 'thin-sort-title'
                "
                >{{ $t("titlet3text") }}</span
              >
              <span v-if="!categoryActive3" class="thin-sort-button">+</span>
              <span v-else class="thin-sort-button">-</span>
            </div>
          </b-col>
          <!-- <b-col>
            <b-img class="this-sort-icon" src="https://cangshurixuan-1302898684.cos.ap-shanghai.myqcloud.com/demo/product-title-group.png"></b-img
          >
          </b-col> -->
        </b-row>
        <div class="productdetail-sort-thin-line"></div>
        <div
          v-if="categoryPanelActive"
          class="prodictdetail-sort-thin-title-group"
        >
          <div
            class="prodictdetail-sort-thin-title"
            v-for="(item, index) in sortlist"
            v-bind:key="index"
          >
            <div
              class="productdetail-sort-thine-title"
              v-for="(item2, index2) in item"
              v-bind:key="index2"
              @click="bindCategoryClick(index * 3 + index2)"
            >
              {{ item2 }}
            </div>
          </div>
        </div>
      </b-container>
    </div>

    <!-- 产品列表 -->
    <div class="productdetail-list">
      <b-container>
        <div class="row" v-if="isRouterAlive">
          <div
            class="col-12 col-sm-6 col-md-4 col-lg-3"
            v-for="(item, index) in $t(productIndex)"
            v-bind:key="index"
          >
            <!-- {{JSON.stringify(productlist[index][index2])}} -->
            <div class="productdetail-item" @click="showDetail(item)">
              <div style="text-align: center">
                <b-img
                  :src="item.img ? item.img[0] : ''"
                  fluid
                  alt="宁波天鑫仪表有限公司"
                ></b-img>
              </div>
              <div class="productdetail-item-name">{{ item.type }}</div>
              <div class="productdetail-item-size">{{ item.name }}</div>
              <div class="productdetail-item-more">{{$t('readmore')}}&emsp;></div>
            </div>
          </div>
        </div>
        <div class="productdetail-load">
          <b-row>
            <b-col cols="2" md="4"> </b-col>
            <b-col cols="8" md="4" style="text-align: center">
              <span class="productdetail-load-page"
                >{{$t('showed')}}{{ listlength }}{{$t('product')}}/{{$t('all')}}{{ total }}{{$t('product')}}</span
              >
              <b-progress :max="total" class="mt-2" variant="gray" height="3px">
                <b-progress-bar :value="listlength">
                  <span> </span>
                </b-progress-bar>
              </b-progress>

              <b-button
                variant="outline-secondary"
                class="productdetail-load-more"
                v-if="listlength < total"
                @click="loadmore()"
                >{{$t('loadmore')}}</b-button
              >
            </b-col>
            <b-col cols="2" md="4"> </b-col>
          </b-row>
        </div>
      </b-container>
    </div>

    <!-- 产品详情 -->
    <b-modal
      body-class="model-product"
      v-model="show"
      centered
      hide-header
      hide-footer
    
    >
    <div   style="position:fixed;z-index: 9999;top:100px;background-color:#ffffff;width:95vw;max-width:500px;">
      <div class="modal-productdetail-header">
        <span class="modal-productdetail-title">{{ itemDetail.type }}</span>
        <div class="modal-productdetail-button" @click="hideDetail">X</div>
      </div>
      <div class="modal-productdetail-body" style="overflow-y:scroll;max-height:80vh;">
        <div class="modal-productdetail-container">
          <div class="modal-productdetail-carousel">
            <b-carousel class="modal-productdetail-slide" no-animation>
              <b-carousel-slide
                v-for="(item, index) in itemDetail.img"
                v-bind:key="index"
                :img-src="item"
              ></b-carousel-slide>
            </b-carousel>
          </div>
        </div>
        <div class="modal-productdetail-grid">
          <div class="productdetail-grid-title">规格参数</div>
          <b-table-simple hover small caption-top responsive>
            <b-thead head-variant="dark">
              <b-tr class="productdetail-grid-head">
                <b-th v-for="(item, index) in gridtitle" v-bind:key="index">{{
                  item
                }}</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr
                class="productdetail-grid-row"
                v-for="(item, index) in gridbody"
                v-bind:key="index"
              >
                <b-td
                  :class="indextd == 0 ? 'productdetail-title-nowrap' : ''"
                  v-for="(itemtd, indextd) in item"
                  v-bind:key="indextd"
                  >{{ itemtd }}</b-td
                >
              </b-tr></b-tbody
            >
          </b-table-simple>
          <div class="productdetail-grid-body"></div>
        </div>
        <div class="productdetail-bottom">
          <b-button class="productdetail-bottom-button" variant="outline-dark" @click="downloadPDF(itemDetail.pdf,itemDetail.key)"
            >下载PDF版本</b-button
          >
        </div>
      </div>
      </div>
    </b-modal>
    <Footer class="w-100" />
  </div>
</template>

<script>
import Slider from "../components/slider2";
import Footer from "../components/footer";
import Sticky from "sticky-js";
export default {
  components: {
    Slider,
    Footer,
  },
  data() {
    return {
      isRouterAlive: true,

      showCategoryPanel: false,
      show: false,

      // 点击样式
      clickActiveColor: "active-red",
      clickList: [],
      clickType: 0,
      clickCategory: 0,

      // 移动样式
      moveActiveColor: "active-red",
      moveList: [],
      moveType: 0,
      moveCategory: 0,

      categoryActive1: false,
      categoryActive2: false,
      categoryActive3: false,
      categoryPanelActive: false,

      activeCategory: 0,

      type: 0,
      category: 0,

      limit: 12,
      page: 1,
      total: 0,
      listlength: 0,

      enList: [],
      zhList: [],

      itemDetail: {},

      sortTitleList: [
        {
          title: "天鑫软管",
          color: "active-red",
          items: [
            "不锈钢波纹软管",
            "金属包覆软管",
            "不锈钢波纹软管",
            "不锈钢波纹软管管件",
            "阀门、管件",
            "金属波纹管膨胀节",
            "波纹金属软管",
          ],
        },
        {
          title: "天鑫仪表",
          color: "active-blue",
          items: [
            "膜式燃气表",
            "IC卡膜式燃气表",
            "无线远传IC卡膜式燃气表",
            "智能控制阀",
            "气体超声流量计",
            "超声波燃气表",
          ],
        },
        {
          title: "解决方案",
          color: "active-black",
          items: [],
        },
      ],
      sortlist: [],
      active: 0,
      activecolor: "active-red",
      activesort: 0,

      products: [],

      productlist: [],

      productIndex: "",

      value: 0,
      max: 1000,

      gridtitle: [],
      gridbody: [],

      key: "仪表",
      sort: "",
    };
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (
        to.query.type != from.query.type ||
        to.query.category != from.query.category
      ) {
        this.moveActiveColor = this.clickActiveColor = this.sortTitleList[
          to.query.type
        ].color;
        this.moveType = this.clickType = to.query.type;
        this.moveCategory = this.clickCategory = to.query.category;
        console.log(this.moveActiveColor);
        this.init(); //重新加载数据
      }
    },
  },
  computed: {
    // products() {
    //   return this.$store.state.products;
    // },
    lan() {
      return this.$store.state.lan;
    },
    productstotal() {
      return this.$store.state.productstotal;
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },

    // 点击类别
    bindTypeClick(index, list) {
      this.setupSort(list);
      this.clickActiveColor = this.moveActiveColor = this.sortTitleList[
        index
      ].color;
      this.clickType = this.moveType = index;
      this.clickCategory = this.moveCategory = 0;
      this.clickList = this.sortlist;
      this.showCategoryPanel = false;

      this.products = [];
      this.loadmore();
    },
    // 移入类别
    bindTypeMoveEnter(index, list) {
      this.setupSort(list);
      this.moveActiveColor = this.sortTitleList[index].color;
      this.moveType = index;
      this.moveCategory = 0;
      this.moveList = this.sortlist;
    },
    //  点击种类
    bindCategoryClick(index) {
      this.clickActiveColor = this.moveActiveColor;
      this.clickCategory = this.moveCategory = index;
      this.clickType = this.moveType;
      this.showCategoryPanel = false;

            this.categoryActive1 = false;
            this.categoryActive2 = false;
            this.categoryActive3 = false;
            this.categoryPanelActive = false;
      this.$router.push({
        path: `/product?type=${parseInt(this.clickType)}&category=${this.clickCategory}`,
      });
      this.init();
    },
    downloadPDF(pdf,key){
      const _this = this;
      if (parseInt(key) == 1 && localStorage.getItem("pwd") != "access") {
        _this.$bvToast.toast(
          `该PDF需要密码才可以打开，3秒后将跳转到密码登录页！`,
          {
            title: "警告",
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
            variant: "danger",
          }
        );
        setTimeout(function () {
          _this.$router.push("/login");
        }, 3000);
      }else{
        window.location.href=pdf
      }
    },
    bindCategoryMoveEnter(index) {
      this.moveCategory = index;
    },
    // 移入鼠标
    bindTypeSpanMoveEnter() {
      this.showCategoryPanel = true;
    },
    // 移除标题栏
    bindProductMoveLeave() {
      this.showCategoryPanel = false;
      this.sortlist = this.clickList;
      this.moveType = this.clickType;
      this.moveCategory = this.clickCategory;
      this.moveActiveColor = this.clickActiveColor;
      this.products = [];
    },
    setupSort(list) {
      let iList = [];
      for (let i = 0; i < list.length / 3; i++) {
        let jList = [];
        for (let j = i * 3; j < 3 * i + 3; j++) {
          if (list[j]) {
            jList.push(list[j]);
          }
        }
        iList.push(jList);
      }
      this.sortlist = iList;
    },
    loadmore() {
      this.page = this.page + 1;
      this.getProductPage(this.enList, this.zhList);
    },
    showDetail(item) {
      this.itemDetail = item;
      let list = Object.values(item.desc);
      this.gridbody = [];
      for (let i = 0; i < list.length; i++) {
        if (i == 0) {
          this.gridtitle = Object.values(list[i]);
        } else {
          this.gridbody.push(Object.values(list[i]));
        }
      }
      console.log(this.gridbody);
      this.show = true;
    },
    hideDetail() {
      this.show = false;
    },
    init() {
      console.log("init");
      this.getProduct();
      this.enList = [];
      this.zhList = [];
      this.limit = 12;
      this.page = 1;
      this.total = 0;
      this.listlength = 0;

      this.moveActiveColor = this.clickActiveColor = this.sortTitleList[
        this.$route.query.type
      ].color;
      this.moveType = this.clickType = this.$route.query.type;
      this.moveCategory = this.clickCategory = this.$route.query.category;

      this.getProductPage(this.enList, this.zhList);
    },
    getProductPage(enList, zhList) {
      const _this = this;
      _this.$store
        .dispatch("getProductPage", {
          limit: _this.limit,
          page: _this.page,
          type: _this.clickType,
          category: _this.clickCategory,
        })
        .then((x) => {
          let en = {};
          let zh = {};
          x.list.forEach((element) => {
            console.log(element.en);
            enList.push(JSON.parse(element.en));
            zhList.push(JSON.parse(element.zh));
          });

          _this.enList = enList;
          _this.zhList = zhList;
          _this.productIndex = `productlist${new Date().getTime()}`;
          en[_this.productIndex] = _this.enList;
          zh[_this.productIndex] = _this.zhList;

          console.log(en);
          _this.listlength = _this.enList.length;
          _this.total = x.total;
          _this.$i18n.mergeLocaleMessage("en", en);
          _this.$i18n.mergeLocaleMessage("zh", zh);
          const sticky = new Sticky(".sticky");
          sticky.update();
          const sticky2 = new Sticky(".sticky2");
          sticky2.update();
        });
    },
    getProduct() {
      const _this = this;
      this.$store.dispatch("getProduct").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);

        let lang = _this.$i18n.locale;
        _this.$i18n.locale = lang;
        _this.reload();
      });
    },
    bindCatgoryClickThin(index, list) {
      console.log(index)
      switch (index) {
        case 1:
          if (this.categoryActive1) {
            this.categoryActive1 = false;
            this.categoryActive2 = false;
            this.categoryActive3 = false;
            this.categoryPanelActive = false;
          } else {
            this.categoryActive1 = true;
            this.categoryActive2 = false;
            this.categoryActive3 = false;
            this.categoryPanelActive = true;
          }
          break;
        case 2:
          if (this.categoryActive2) {
            this.categoryActive1 = false;
            this.categoryActive2 = false;
            this.categoryActive3 = false;
            this.categoryPanelActive = false;
          } else {
            this.categoryActive1 = false;
            this.categoryActive2 = true;
            this.categoryActive3 = false;
            this.categoryPanelActive = true;
          }
          break;
        case 3:
          if (this.categoryActive3) {
            this.categoryActive1 = false;
            this.categoryActive2 = false;
            this.categoryActive3 = false;
            this.categoryPanelActive = false;
          } else {
            this.categoryActive1 = false;
            this.categoryActive2 = false;
            this.categoryActive3 = true;
            this.categoryPanelActive = true;
          }
          break;
      }

      this.setupSort(list);
      this.clickActiveColor = this.moveActiveColor = this.sortTitleList[
        parseInt(index)-1
      ].color;
      this.clickType = this.moveType = parseInt(index)-1;
      this.clickCategory = this.moveCategory = 0;
      this.clickList = this.sortlist;
      this.showCategoryPanel = false;

      this.products = [];
      this.loadmore();
    },
  },
  updated() {},
  mounted() {
    // this.init();
  },

  created() {
    this.init(); //重新加载数据
  },
};
</script>
<style>
.slider-title {
  margin-left: 115px;
  color: #fff;
  font-size: 42px;
  font-weight: bold;
}
.slider-subtitle {
  margin-left: 115px;
  color: #fff;
  font-size: 20px;
  font-weight: 100;
}

@media only screen and (max-width: 500px) {
  .slider-title {
    margin-left: 65px;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
  }
  .slider-subtitle {
    margin-left: 65px;
    color: #fff;
    font-size: 10px;
    font-weight: 100;
  }
}
.productdetail-title {
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 23px;
  font-weight: bold;
  border-bottom: 0.5px #bdbdbd88 solid;
  background-color: #fff;
}
.productdetail-sort {
  color: #808080;
  font-weight: 200;
  margin-bottom: 10px;
  font-size: 16px;
  cursor: pointer;
}
.active-red {
  color: #c00f31;
  font-weight: bold;
}

/* 产品系列标题栏 */
.productdetail-title-item {
  white-space: nowrap;
  color: #888888;
  cursor: pointer;
}
.productdetail-title-item span {
  padding-top: 20px;
  padding-bottom: 22px;
  height: 75px;
}
.productdetail-title-item.active-red span {
  color: #c00f31;
  border-bottom: 2px #c00f31 solid;
}
.productdetail-title-item.active-blue span {
  color: #001d80;
  border-bottom: 2px #001d80 solid;
}
.productdetail-title-item.active-black span {
  color: #000000;
  border-bottom: 2px #000000 solid;
}
.active-blue {
  color: #001d80;
  font-weight: bold;
}
.active-black {
  color: #000000;
  font-weight: bold;
}
.productdetail-sort-group {
  padding-top: 50px;
  padding-bottom: 50px;
}
.productdetail-sort-bg {
  box-shadow: 0px 7px 7px -7px #ededed;
}
.productdetail-item {
  background-color: #ededed;
  padding: 30px;
  margin-top: 30px;
}
.productdetail-item:hover {
  -webkit-box-shadow: #00000034 0px 0px 10px;
  -moz-box-shadow: #00000034 0px 0px 10px;
  box-shadow: #00000034 0px 0px 10px;
}

.productdetail-item-name {
  color: #000;
  font-size: 16px;
  font-weight: bold;
}
.productdetail-item-size {
  color: #808080;
  font-size: 16px;
  font-weight: 100;
  height:40px;
}
.productdetail-item-more {
  margin-top: 10px;
  cursor: pointer;
  font-size: 13px;
}
.productdetail-list {
  padding-bottom: 50px;
}
.productdetail-load {
  margin-top: 50px;
}
.productdetail-load-page {
  word-break: keep-all;
}
.progress {
  background-color: #c0c4c8;
}
.progress-bar {
  background-color: #808080;
}
.productdetail-load-more {
  margin-top: 50px;
  font-weight: 300;
  color: #c0c4c8;
  border: 1px #c0c4c8 solid;
  border-radius: 0;
  padding-left: 50px;
  padding-right: 50px;
  word-break: keep-all;
}
.productdetail-load-more:hover {
  box-shadow: #00000034 0px 0px 0px;
}
.productdetail-load-more:after {
  box-shadow: #00000034 0px 0px 0px;
}

.modal-header {
  text-align: center;
}

h5.modal-title {
  font-size: 16px;
  font-weight: normal;
}
.modal-productdetail-header {
  width: 100%;
  height: 60px;
  padding-top: 15px;
  text-align: center;
  border-bottom: 0.5px solid #88888866;
}
.modal-productdetail-title {
  margin-top: 20px;
  height: 60px;
  font-weight: 100;
  font-size: 20px;
}
.productdetail-sort-thin {
  display: none;
}
@media only screen and (max-width: 500px) {
  /* 标题栏 */
  .productdetail-sort-thin-group {
    padding: 16px 0;
  }
  .thin-sort-title-active {
    color: #c00f31;
    font-weight: bold;
  }
  .thin-sort-title {
    color: #888888;
    font-weight: normal;
  }
  .thin-sort-button {
    font-size: 20px;
    margin-left: 5px;
    font-weight: bold;
  }
  .productdetail-sort-thin-line {
    border-bottom: 0.5px solid #88888866;
  }
  .this-sort-icon {
    height: 16px;
    width: 16px;
  }
  .productdetail-sort-thine-title {
    color: #808080;
    font-size: 15px;
    padding-top: 15px;
  }

  .modal-productdetail-title {
    font-size: 15px;
  }
  .productdetail-sort-wide {
    display: none;
  }
  .productdetail-sort-thin {
    display: block;
  }
  .thin-sort-header {
    white-space: nowrap;
  }
  .productdetail-load-more {
    margin-top: 30px;
  }
}
.modal-productdetail-button {
  font-size: 25px;
  position: absolute;
  font-weight: 100;
  color: #888888;
  top: 10px;
  right: 20px;
  cursor: pointer;
}
.model-product {
  
  padding: 0;
  border-radius: 0;
}
.modal-content {
  border-radius: 0;
}
.modal-productdetail-slide li {
  width: 10px;
  height: 10px;
  border: 1px solid #00000000;
  background-color: #717171;
  border-radius: 10px;
}
.modal-productdetail-slide li.active {
  width: 10px;
  height: 10px;
  border: 1px solid #00000000;
  background-color: #000;
  border-radius: 10px;
}
.modal-productdetail-grid {
  border-top: 0.5px solid #dee2e6;
}
.productdetail-grid-title {
  color: #000;
  font-size: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: 100;
}
.productdetail-grid-head {
  background-color: #000;
  width: 100%;
}
.productdetail-grid-head th {
  color: #808080;
  font-size: 13px;
  font-weight: 100;
  white-space: nowrap;
}

.productdetail-title-nowrap {
  white-space: nowrap;
}
.modal-productdetail-body {
   overflow-y:scroll;
  padding: 0 20px;
}
.productdetail-grid-row {
  font-weight: 100;
  color: #808080;
  font-size: 12px;
  border-bottom: 1px solid #dee2e6;
}
.productdetail-bottom {
  width: 100%;
  text-align: center;
  padding-bottom: 20px;
}
.productdetail-bottom-button {
  border-radius: 0;
  font-size: 12px;
  padding: 5px;
}
.modal-productdetail-container {
  width: 100%;
  text-align: center;
}
.modal {
 z-index: 2147483647;
}
.modal-dialog {
  z-index: 2147483647;
}
</style>
